import { useState, useEffect } from "react"
import AuthenticatedLayout from "@components/layout/Authenticated"
import { Box, Text, HStack, Button, ButtonGroup, MenuItem, VStack, Radio, StackDivider, Input, 
    Textarea, Center, IconButton, useDisclosure, RadioGroup, Checkbox, List, ListItem, Stack, Select,
    Switch
} from "@chakra-ui/react"
import { RiCloseFill } from "@remixicon/react"
import {ModalAsset} from "@utils/assets"
import { FieldControl } from "@components/form"
import UploadMedia from "@modules/media/components/UploadMedia"
import rules from "@utils/rules.json"
import { useValidator } from "@handlers/index"
import { useSettingsService } from "@services/index"

const ShippingForm = ({isOpen, onClose, shipping, getShippings, onDetailOpen, setItem}) => {

    const {isOpen: isMediaOpen, onOpen: onMediaOpen, onClose:onMediaClose} = useDisclosure()

    const [errors, setError] = useState({})
    const [data, setData] = useState(
        { 
            name: '',
            image: '',
            description: '',
            status: false
        }
    );

    const { createShipping, response:new_shipping, requestErrors, load } = useSettingsService()
    const {validate, validationErrors} = useValidator(rules.create_shipping)

    //Adds Validation Errors to Error State
    useEffect(() => {
        setError(validationErrors)
    }, [validationErrors])

    //Adds Request Errors to Error State
    useEffect(() => {
        setError(requestErrors)
    }, [requestErrors])



    useEffect(() => {
        if (new_shipping?.shipping) {
            onClose(new_shipping?.shipping)
            if(onDetailOpen) onDetailOpen()
            if(setItem) setItem(new_shipping?.shipping)
            if(getShippings) getShippings()
            setData({ 
                name: '',
                image: '',
                description: '',
                status: false
            })
        }
    }, [new_shipping])

    useEffect(() => {
        if (shipping) {
            setData({
                ...data,
                name: shipping?.name,
                image: shipping?.image,
                description: shipping?.description,
                status: shipping?.status
            })
        }
    }, [shipping])

    const onHandleChange = (name, value) => {
        setData((prevData) => ({ ...prevData, [name]: value }));
        validate(name, value)
    };

    const onSelectMedia = (media) => {
        onHandleChange('image', media);
    }

    const submit = () => {
        if (!isDisabled) {
            createShipping({...data,  id: shipping?.id})
        }
    }

    const isDisabled = load || Object.keys(data).some(field =>  data[field] === '' ) || Object.keys(errors).length > 0;


    return (
        
        <Box>

            <ModalAsset

                modalProps={{isOpen, onClose, isCentered: true, size: {base: 'full', lg: 'lg'}, closeOnOverlayClick: false}}
                headerContent={
                <Box>
                    <Text className="font-semibold capitalize">{shipping ? `Edit ${shipping?.name}` : 'Create Shipping Option'}</Text>
                    <Text className="text-xs font-normal text-gray-400">
                        {shipping ? 'Modify existing shipping details, including rates and delivery zones.' : 'Add a new shipping method with custom rates and delivery areas.'}
                    </Text>
                </Box>
                }
                bodyContent={
                    <VStack spacing={7} className="!items-start !justify-center">
                                                
                        <FieldControl error={errors?.name?.[0]} label={'Name'}>
                            <Input 
                                size={{base: 'lg', lg: 'md'}} 
                                fontSize={'xs'} 
                                placeholder="Enter shipping name" 
                                value={data.name}  
                                onChange={(event) => onHandleChange('name', event.target.value)} 
                            />
                        </FieldControl>
                        
                        <FieldControl error={errors?.image?.[0]} label={'Logo'}>
                            <Box className="w-[90px] h-[90px] border p-2 relative">
                                {
                                    data?.image &&
                                    <HStack className="z-20 absolute top-2 right-2 cursor-pointer">
                                        <RiCloseFill onClick={() => onHandleChange('image', '')} size={20} className="text-red-500" />
                                    </HStack>
                                }
                                <VStack className="h-full !justify-center !items-center">
                                    <Box onClick={onMediaOpen} className="cursor-pointer">
                                        {
                                            data?.image ? 
                                            <img src={data?.image} width={50} /> :
                                            <img src={'/bg/products/no-image.png'} width={50} />
                                        }
                                    </Box>
                                </VStack>
                            </Box>
                        </FieldControl>

                        <FieldControl error={errors?.description?.[0]} label={'Description'}>
                            <Textarea 
                                size={{base: 'lg', lg: 'md'}} 
                                fontSize={'xs'} 
                                placeholder="Enter shipping description" 
                                value={data.description}  
                                onChange={(event) => onHandleChange('description', event.target.value)} 
                            />
                        </FieldControl>

                        <FieldControl label={'Status'}>
                            <Switch isChecked={data?.status} onChange={(event) => onHandleChange('status', event.target.checked)}  />
                        </FieldControl>
                        
                    </VStack>
                }
                footerContent={
                    <ButtonGroup>
                        <Button size={'sm'} onClick={onClose} className="border">Cancel</Button>
                        <Button size={'sm'} onClick={submit} isDisabled={isDisabled} isLoading={load} className="!bg-primary-950 !text-white">Save Changes</Button>
                    </ButtonGroup>
                }

            />

            <UploadMedia isOpen={isMediaOpen} onClose={onMediaClose} onSelectMedia={onSelectMedia} />

        </Box>

    )

}


export default ShippingForm